import { Actions, ActionTypes } from '@appStore/help/actions';
import { Guide } from '@model';

export interface State {
  guidesLoading: boolean;
  guidesLoaded: boolean;
  guides: Guide[];
}

export const initialState: State = {
  guidesLoading: false,
  guidesLoaded: false,
  guides: []
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.GuidesLoad:
      return { ...state, guidesLoaded: false, guidesLoading: true };

    case ActionTypes.GuidesLoadSuccess:
      return { ...state, guidesLoaded: true, guidesLoading: false, guides: action.payload };

    case ActionTypes.GuidesLoadFail:
      return { ...state, guidesLoaded: false, guidesLoading: false };
  }
  return state;
}

export const _getAllGuides = (state: State) => state.guides;
export const _getGuidesLoaded = (state: State) => state.guidesLoaded;
export const _getGuidesLoading = (state: State) => state.guidesLoading;
